<template>
  <component :is="`ve-${type}`" :data="data" :settings="settings"></component>
</template>

<script>
import veCount from './ve-count'
import veTable from './ve-table'
export default {
  name: 'lyai-view',
  components: {
    veCount,
	veTable
  },
  props: {
    type: {
      type: String
    },
    data: {
      type: Object
    },
    settings: {
      type: Object
    }
  }
}
</script>
